<script>
    import { addActiveAudio, removeActiveAudio } from 'stores/audioStore';
    import AudioUtil from 'util/AudioUtil';
    import { fetchAudio } from 'util/TextToSpeechUtil';
    import Icon from 'views/components/icon/Icon.svelte';

    export let pairId
    export let value
    export let lang
    export let disabled = false

    export function play(event) {
        event?.stopPropagation()
        startAudio()
    }

    const url = `/training/synthesize?pairId=${pairId}&value=${value}&lang=${lang}`
    const maxAttempts = 10
    const audio = new Audio()
    let isLoading = false

    audio.addEventListener('play', () => {
        AudioUtil.stopAllAudio(audio)
        addActiveAudio(audio)
    })
    audio.addEventListener('pause', () => {
        removeActiveAudio(audio)
    })
    audio.addEventListener('ended', () => {
        removeActiveAudio(audio)
    })

    async function startAudio(attempt = 0) {
        if (isLoading) {
            return
        }

        isLoading = true

        attempt++

        try {
            const blob = await fetchAudio(url, true)

            Backbone.View.layout.closeStatus()

            audio.src = URL.createObjectURL(blob)
            await audio.play()

            isLoading = false
        } catch (error) {
            if (error.error_code === 35202) {
                if (attempt > maxAttempts) {
                    isLoading = false
                    Backbone.View.layout.openStatus(
                        window.i18n.gettext('The audio could not be downloaded. Try again later.')
                    )
                } else if (_.isString(url)) {
                    // Only start another attempt if url is a string (single URL). Retry logic for list of URLs
                    // is handled in TextToSpeechUtil
                    setTimeout(() => {
                        isLoading = false
                        startAudio(attempt)
                    }, 500)
                    if (attempt === 4) {
                        Backbone.View.layout.openStatus(error.displayMessage, 'loading', {noHide: true})
                    }
                }
            } else {
                if (error?.displayMessage) {
                    Backbone.View.layout.openStatus(error.displayMessage);
                } else {
                    Backbone.View.layout.closeStatus()
                }

                isLoading = false
            }
        }
    }
</script>

<button class="button" disabled={isLoading || disabled} on:click={play}>
    <Icon name="volume-up"></Icon>
</button>

<style lang="scss">
    .button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        margin-left: 10px;
        padding: 0;
        vertical-align: middle;
        border-radius: 50%;
        background: $blue;
        color: $white;

        &:hover {
            background: darken($blue, 10%);
        }

        &:active {
            background: lighten($blue, 10%);
        }

        :global(svg) {
            fill: currentColor;
            width: 16px;
            height: 16px;
        }
    }
</style>
